module.exports = require("././angular-sanitize.js");


//////////////////
// WEBPACK FOOTER
// angular-sanitize (bower component)
// module id = 1032
// module chunks = 1